import { LoginConfigTypes } from './types/login-config-types';

export const LoginConfig: LoginConfigTypes = {
    xxxFeatureToggle: {
        value: 'Y',
    },

    exposedPersonFinancialInstUrl: {
        value: 'https://pd.fss.or.kr',
    },
};
